import React from 'react';
import DevelopmentLayout from '../../components/Layouts/DevelopmentLayout';

const DevelopmentPage = ({children}) => <DevelopmentLayout />;

export default DevelopmentPage;
